import { BaseService } from '../base';
import type { PlanResource, PlanResourceDetail } from './types';

export class PlanResourcesService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async listByProduct(productId: string): Promise<{
    success: boolean;
    data?: PlanResource[];
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/${productId}/plans`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<PlanResource[]>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar assistências',
      };
    }
  }

  async getByPlan(code: string): Promise<{
    success: boolean;
    data?: PlanResourceDetail[];
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/plans/${code}`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<PlanResourceDetail[]>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar recursos do plano',
      };
    }
  }
}

export const planResourcesService = new PlanResourcesService();
